module.exports = __webpack_public_path__ + "static/media/ribbon.763f151c.svg";